import "core-js/modules/es6.reflect.construct.js";
import _toConsumableArray from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find-index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import moment from 'moment';
import BaseModel from "./BaseModel";
import LoanRepayment from "./LoanRepayment";
import PaymentPlan from "./PaymentPlan";
var Loan = /*#__PURE__*/function (_BaseModel) {
  function Loan(params) {
    var _this;
    _classCallCheck(this, Loan);
    _this = _callSuper(this, Loan, [params]);
    _this._statuses = {
      1: 'Regular',
      2: 'Payment Plan',
      3: 'Frozen',
      4: 'Dead',
      5: 'Default',
      6: 'Money Claim',
      7: 'Fraud',
      8: 'Deceased Customer',
      9: 'Modified',
      10: 'DMP',
      11: 'IVA',
      12: 'AOE - Requested',
      13: 'AOE - Suspended',
      14: 'AOE - Full Order',
      15: 'Delinquent',
      16: 'Death Row',
      17: 'Debt Collection',
      18: 'Early Settlement'
    };
    return _this;
  }
  _inherits(Loan, _BaseModel);
  return _createClass(Loan, [{
    key: "repayments",
    value: function repayments() {
      var repayments = [];
      var promiseToPay = this.get('active_promise_to_pay');
      var loanRepayments = this.get('repayments');
      if (promiseToPay) {
        var paidRepayments = loanRepayments.filter(function (repayment) {
          return +repayment.is_paid === 1;
        });
        repayments = [].concat(_toConsumableArray(paidRepayments), _toConsumableArray(promiseToPay.repayments));
      } else {
        repayments = loanRepayments;
      }
      return repayments.map(function (repayment) {
        return new LoanRepayment(repayment);
      });
    }
  }, {
    key: "paidRepayments",
    value: function paidRepayments() {
      return this.repayments().filter(function (repayment) {
        return repayment.isPaid();
      });
    }
  }, {
    key: "unpaidRepayments",
    value: function unpaidRepayments() {
      return this.repayments().filter(function (repayment) {
        return !repayment.isPaid();
      });
    }
  }, {
    key: "missedPayments",
    value: function missedPayments() {
      return this.unpaidRepayments().filter(function (repayment) {
        return repayment.isOverdue();
      });
    }
  }, {
    key: "isOverdue",
    value: function isOverdue() {
      return this.missedPayments().length > 0;
    }
  }, {
    key: "isPayable",
    value: function isPayable() {
      return !['Dead', 'Deceased Customer'].includes(this.status());
    }
  }, {
    key: "paidAmount",
    value: function paidAmount() {
      return this.paidRepayments().reduce(function (acc, repayment) {
        return acc + repayment.amount();
      }, 0);
    }
  }, {
    key: "unpaidAmount",
    value: function unpaidAmount() {
      return this.unpaidRepayments().reduce(function (acc, repayment) {
        return acc + repayment.amount();
      }, 0);
    }
  }, {
    key: "discount",
    value: function discount() {
      return this.get('discounts').reduce(function (acc, cur) {
        return acc - Number(cur.amount);
      }, 0);
    }
  }, {
    key: "unallocatedDiscount",
    value: function unallocatedDiscount() {
      var repaymentsDiscount = this.repayments().reduce(function (acc, repayment) {
        return acc + repayment.discount();
      }, 0);
      var unallocatedDiscount = repaymentsDiscount + this.discount();
      return unallocatedDiscount < 0 ? unallocatedDiscount : 0;
    }
  }, {
    key: "charges",
    value: function charges() {
      return this.get('charges').reduce(function (acc, cur) {
        return acc + Number(cur.cost);
      }, 0);
    }
  }, {
    key: "currentBalance",
    value: function currentBalance() {
      return this.unpaidAmount() + this.accruedInterest() + this.unallocatedDiscount();
    }
  }, {
    key: "accruedInterest",
    value: function accruedInterest() {
      return parseFloat(this.get('loan_attributes').unallocated_accrued_int);
      // if(frozen_date is not null and frozen_date < date_add(l.loan_date, INTERVAL seq DAY),
      //   0.00,
      //   cast((l.amount - ifnull((sum(sum(lrs.capital)) over
      //   (partition by l.id  order by  l.id, seq asc)), 0) + ifnull(lrs.capital, 0)) * 0.007 as decimal(8, 6)))
    }
  }, {
    key: "total",
    value: function total() {
      return this.repayments().reduce(function (acc, repayment) {
        return acc + repayment.amount();
      }, 0);
    }
  }, {
    key: "amount",
    value: function amount() {
      return Number(this.get('amount'));
    }
  }, {
    key: "paidPercent",
    value: function paidPercent() {
      return Math.round(this.paidAmount() / this.total() * 100);
    }
  }, {
    key: "paidCount",
    value: function paidCount() {
      return this.paidRepayments().length;
    }
  }, {
    key: "paidDiffForRepayment",
    value: function paidDiffForRepayment(i) {
      var total = this.contractualPlan().repayments().slice(0, i + 1).reduce(function (acc, cur) {
        return acc + cur.amount();
      }, 0);

      // subtract discount from last repayment
      if (i === this.contractualPlan().repayments().length - 1) {
        total -= this.discount();
      }
      return total - this.paidAmount();
    }
  }, {
    key: "overdueData",
    value: function overdueData() {
      var _this2 = this;
      var ODRepayments = this.contractualPlan().overdueRepayments();
      var ODRepaymentIndex = ODRepayments.findIndex(function (r, i) {
        return _this2.paidDiffForRepayment(i) > 0;
      });
      if (ODRepaymentIndex < 0) {
        return false;
      }
      var ODRepayment = ODRepayments[ODRepaymentIndex];
      var days = moment().diff(ODRepayment.date(), 'days');
      var amount = this.contractualPlan().overdueRepayments().reduce(function (acc, val) {
        return acc + val.amount();
      }, 0) - this.paidAmount() + this.charges() - this.discount();
      return {
        days: days,
        amount: amount
      };
    }
  }, {
    key: "contractualRepaymentPaidStatus",
    value: function contractualRepaymentPaidStatus(i) {
      var diff = this.paidDiffForRepayment(i);
      var contractualAmount = this.contractualPlan().repayments()[i].amount();

      // paid
      if (diff <= 0) return true;

      // not paid
      if (diff >= contractualAmount) return false;

      // partly paid percentage
      return (contractualAmount - diff) / contractualAmount;
    }
  }, {
    key: "earlySettlementAmount",
    value: function earlySettlementAmount() {
      return this.get('loan_attributes').pay_off_now;
    }
  }, {
    key: "nextRepayment",
    value: function nextRepayment() {
      return this.overdueRepayments().sort(function (a, b) {
        return moment(a.get('created_at')).diff(moment(b.get('created_at')));
      })[0];
    }
  }, {
    key: "accruesInterest",
    value: function accruesInterest() {
      return this.overdueRepayments().length && !(this.isFrozen() || this.exceededCap() || this.inBreathingSpace());
    }
  }, {
    key: "isFrozen",
    value: function isFrozen() {
      return this.get('frozen_date') && moment(this.get('frozen_date')) < moment();
    }
  }, {
    key: "exceededCap",
    value: function exceededCap() {
      return parseFloat(this.get('total_interest')) >= parseFloat(this.get('cap'));
    }
  }, {
    key: "overdueRepayments",
    value: function overdueRepayments() {
      return this.unpaidRepayments().filter(function (repayment) {
        return repayment.isOverdue();
      });
    }
  }, {
    key: "firstRepayment",
    value: function firstRepayment() {
      return this.unpaidRepayments().sort(function (a, b) {
        return moment(a.get('created_at')).diff(moment(b.get('created_at')));
      })[0];
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.get('closed') === 0;
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.get('loan_status_id') === 5;
    }
  }, {
    key: "inBreathingSpace",
    value: function inBreathingSpace() {
      return this.get('loan_status_id') === 19;
    }
  }, {
    key: "inLegalStatus",
    value: function inLegalStatus() {
      return [6, 7, 12, 13, 14, 15, 16, 17].includes(this.get('loan_status_id'));
    }
  }, {
    key: "settledEarly",
    value: function settledEarly() {
      return this.get('loan_status_id') === 18 && !this.isOpen();
    }
  }, {
    key: "onContractualPlan",
    value: function onContractualPlan() {
      return this.paymentPlans().length === 1;
    }
  }, {
    key: "contractualPlan",
    value: function contractualPlan() {
      return this.paymentPlans()[0];
    }
  }, {
    key: "paymentPlans",
    value: function paymentPlans() {
      return this.get('payment_plans').map(function (plan) {
        return new PaymentPlan(plan);
      });
    }
  }, {
    key: "status",
    value: function status() {
      var statusId = this.get('loan_status_id');
      switch (true) {
        case statusId === 1 && !this.isOverdue():
          return 'Payment Up-to-date';
        case statusId === 1 && this.isOverdue():
          return 'Overdue';
        case this.inLegalStatus():
          return 'Legal Proceedings';
        case this.isDefault():
          return 'Default';
        case this.settledEarly():
          return 'Early Settlement';
        case !this.onContractualPlan():
          return 'Payment Arrangement';
        default:
          return this._statuses[statusId];
      }
    }
  }, {
    key: "duration",
    value: function duration(repaymentIndex) {
      // var repayment = this.repayments()[repaymentIndex]
      // var dateKey = repayment.isPaid() ? 'date_paid' : 'payment_date'

      var dateKey = 'payment_date';
      var repaymentDate = moment(this.repayments()[repaymentIndex].get(dateKey));
      var prevRepayment = repaymentIndex > 0 ? this.repayments()[repaymentIndex - 1] : null;
      var prevRepaymentDate;
      if (prevRepayment) {
        prevRepaymentDate = prevRepayment.get('payment_date');

        // prevRepayment.isPaid() ? prevRepayment.get('date_paid') :  prevRepayment.get('payment_date')

        prevRepaymentDate = moment(prevRepaymentDate);
      } else {
        prevRepaymentDate = moment(this.get('loan_date'));
      }
      return repaymentDate.diff(prevRepaymentDate, 'days');
    }
  }, {
    key: "lastRepayment",
    value: function lastRepayment() {
      return this.repayments().sort(function (a, b) {
        return moment(b.get('payment_date')).diff(moment(a.get('payment_date')));
      })[0];
    }
  }, {
    key: "dailyInterest",
    value: function dailyInterest() {
      var interestRate = 0.007;
      var outstandingCapital = this.unpaidRepayments().reduce(function (acc, repayment) {
        return acc + Number(repayment.get('capital'));
      }, 0);
      return outstandingCapital * interestRate;
    }
  }]);
}(BaseModel);
export default Loan;